/* eslint-disable complexity */
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import cx from 'classnames'
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'

import withMemo from '../../decorators/withMemo'
import { Button, RichText } from '..'

import useStyles from './styles'


const CreateForm = (props) => {
  const classes = useStyles(props)
  const {
    className,
    defaultEmail,
    formEmailLabel,
    formCivilityLabel,
    formCivilityMr,
    formCivilityMs,
    formCivilityMx,
    formCivilityNa,
    formFirstnameLabel,
    formLastnameLabel,
    errorRequiredFields,
    errorEmailFormat,
    formSuccessMessage,
    signUpErrorMessage,
    newsletterOptinText,
    understandOptinText,
    acceptTOUText,
    formSignupLabel,
    submitHandler,
    formSubmittedSuccess,
    formSubmittedError,
    policiesProps,
  } = props

  // * HANDLERS

  const SignupSchema = Yup.object().shape({
    email: Yup.string()
      .email(errorEmailFormat)
      .min(1, '').required(),
    lastName: Yup.string().required(),
    firstName: Yup.string().required(),
    civility: Yup.string().required(),
    touConsent: Yup.bool().required().oneOf([true]),
    consent: Yup.bool().required().oneOf([true]),
    understand: Yup.bool().required().oneOf([true]),
  })

  const handleSubmit = useCallback((values) => {
    if (submitHandler) {
      submitHandler(values)
    }
  }, [submitHandler])

  // RETURN

  return (
    <div
      className={cx(classes.container, className)}
    >
      <img
        src="data:image/png;base64,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"
        className={classes.image}
        alt=" "
      />
      <Formik
        initialValues={{
          email: defaultEmail,
          firstName: '',
          lastName: '',
          civility: '',
          consent: false,
          understand: false,
          touConsent: false,
        }}
        validationSchema={SignupSchema}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, getFieldProps }) => (!formSubmittedSuccess ? (
          <Form className={classes.form}>

            <div className={classes.control}>
              {formEmailLabel && (
                <label
                  className={classes.label}
                  htmlFor="email"
                >
                  {formEmailLabel}
                </label>
              )}
              <Field
                id="email"
                name="email"
                type="text"
                className={cx(classes.input, errors.email && 'is-error')}
                {...getFieldProps('email')}
              />
            </div>
            {errors.email && touched.email ? (
              <div className={classes.error}>{errors.email}</div>
            ) : null}

            <div className={classes.row}>
              <div className={classes.control}>
                {formFirstnameLabel && (
                  <label
                    className={classes.label}
                    htmlFor="firstName"
                  >
                    {formFirstnameLabel}
                  </label>
                )}
                <Field
                  id="firstName"
                  name="firstName"
                  type="text"
                  className={cx(classes.input, errors.firstName && 'is-error')}
                />
              </div>
              <div className={classes.control}>
                {formLastnameLabel && (
                  <label
                    className={classes.label}
                    htmlFor="lastName"
                  >
                    {formLastnameLabel}
                  </label>
                )}
                <Field
                  id="lastName"
                  name="lastName"
                  type="text"
                  className={cx(classes.input, errors.lastName && 'is-error')}
                />
              </div>
            </div>

            <p className={classes.civilityLabel}>{formCivilityLabel}</p>
            <div className={cx(classes.radios, errors.civility && 'is-error')}>
              <div className={classes.radio}>
                <Field
                  type="radio"
                  name="civility"
                  id="radio1"
                  value="mr"
                />
                <label
                  htmlFor="radio1"
                >
                  {formCivilityMr}
                </label>
              </div>
              <div className={classes.radio}>
                <Field
                  type="radio"
                  name="civility"
                  id="radio2"
                  value="miss"
                />
                <label
                  htmlFor="radio2"
                >
                  {formCivilityMs}
                </label>
              </div>
              <div className={classes.radio}>
                <Field
                  type="radio"
                  name="civility"
                  id="radio3"
                  value="mx"
                />
                <label
                  htmlFor="radio3"
                >
                  {formCivilityMx}
                </label>
              </div>
              <div className={classes.radio}>
                <Field
                  type="radio"
                  name="civility"
                  id="radio4"
                  value="none"
                />
                <label
                  htmlFor="radio4"
                >
                  {formCivilityNa}
                </label>
              </div>
            </div>

            <div className={classes.legals}>
              {policiesProps && <RichText {...policiesProps} />}
              {acceptTOUText && (
                <div className={cx(classes.optinContainer, errors.touConsent && 'is-error')}>
                  <Field
                    id="touConsent"
                    name="touConsent"
                    type="checkbox"
                  />
                  <label
                    htmlFor="touConsent"
                    className={classes.controlCheckbox}
                  >
                    {acceptTOUText}
                  </label>
                </div>
              )}
              {newsletterOptinText && newsletterOptinText !== 'newsletter_optin_text' && (
                <div className={cx(classes.optinContainer, errors.consent && 'is-error')}>
                  <Field
                    id="consent"
                    name="consent"
                    type="checkbox"
                  />
                  <label
                    htmlFor="consent"
                    className={classes.controlCheckbox}
                  >
                    {newsletterOptinText}
                  </label>
                </div>
              )}
              {understandOptinText && (
                <div className={cx(classes.optinContainer, errors.understand && 'is-error')}>
                  <Field
                    id="understand"
                    name="understand"
                    type="checkbox"
                  />
                  <label
                    htmlFor="understand"
                    className={classes.controlCheckbox}
                  >
                    {understandOptinText}
                  </label>
                </div>
              )}
            </div>

            {errors.lastName || errors.civility || errors.firstName || errors.email || errors.touConsent || errors.consent || errors.understand ? (
              <div className={classes.errorMessage}>{errorRequiredFields}</div>
            ) : null}
            {formSubmittedError ? (
              <div className={classes.errorMessage}>{signUpErrorMessage}</div>
            ) : null}
            <div className={classes.actions}>
              <button
                className={classes.action}
                type="submit"
              >
                <Button>
                  {formSignupLabel}
                </Button>
              </button>
            </div>
          </Form>
        ) : (
          <div
            className={classes.successMessage}
          >
            {formSuccessMessage}
          </div>


        ))}
      </Formik>
    </div>
  )
}

export const FormPropTypes = {
  className: PropTypes.string,
  defaultEmail: PropTypes.string,
  formEmailLabel: PropTypes.string,
  formCivilityLabel: PropTypes.string,
  formCivilityMr: PropTypes.string,
  formCivilityMs: PropTypes.string,
  formCivilityMx: PropTypes.string,
  formCivilityNa: PropTypes.string,
  formFirstnameLabel: PropTypes.string,
  formLastnameLabel: PropTypes.string,
  readOurPolicyText: PropTypes.string,
  newsletterOptinText: PropTypes.string,
  understandOptinText: PropTypes.string,
  formSuccessMessage: PropTypes.string,
  formSignupLabel: PropTypes.string,
  errorRequiredFields: PropTypes.string,
  errorEmailFormat: PropTypes.string,
  signUpErrorMessage: PropTypes.string,
  acceptTOUText: PropTypes.string,
  submitHandler: PropTypes.func,
  formSubmittedSuccess: PropTypes.bool,
  formSubmittedError: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  policiesProps: PropTypes.object,
  onCheckboxLinkClick: PropTypes.func,
}

CreateForm.propTypes = FormPropTypes

CreateForm.defaultProps = {
  className: null,
  defaultEmail: '',
  formEmailLabel: '',
  formCivilityLabel: '',
  formCivilityMr: '',
  formCivilityMs: '',
  formCivilityMx: '',
  formCivilityNa: '',
  formFirstnameLabel: '',
  formLastnameLabel: '',
  errorRequiredFields: '',
  errorEmailFormat: '',
  signUpErrorMessage: '',
  formSuccessMessage: '',
  readOurPolicyText: '',
  newsletterOptinText: '',
  understandOptinText: '',
  acceptTOUText: '',
  formSignupLabel: '',
  policiesProps: null,
  formSubmittedSuccess: false,
  formSubmittedError: false,
  submitHandler: () => null,
  onCheckboxLinkClick: () => null,
}

export default withMemo()(CreateForm)
